import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { InputAdornment } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import Modal from 'components/Tvendo/Common/ModalBase';
import ModalFilterBPartner from 'components/Tvendo/Common/ModalFilterBPartner';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsGetAll, wsFindBy } from 'services/WService.js';
import { WithApp } from 'contexts/appContext';

// 3 = ARCOR en base_layer_divitions. Las mesas se filtran por la división y no
// por el nombre, que puede cambiar.
const DIVISION_ARCOR = 3;

// La planilla no lleva fechas: todo entra de Alta con la fecha del día, y la
// baja se hace después con el botón del listado.
const COLUMNAS_EXCEL = ['MESA', 'CLIENTE', 'MUEBLE'];

const limpio = (v) => (v === null || v === undefined ? '' : String(v).trim());

export default WithApp(function ModalCustomerFurniture(props) {
  const control = props.model;
  const esNuevo = !control?.id;

  const [bureaus, setBureaus] = useState([]);
  const [furnitures, setFurnitures] = useState([]);
  const [dataImport, setDataImport] = useState({});
  const [items, setItems] = useState([]);

  const [dataChanging, setDataChanging] = useState({});
  const [openModalBPartner, setOpenModalBPartner] = useState(false);
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);

  const importado = dataImport?.success === true;

  function handleChange(field, value) {
    setDataChanging((prev) => ({ ...prev, [field]: value }));
  }

  async function loadCombos() {
    let [resBureaus, resFurnitures] = await Promise.all([
      wsFindBy('base/bureau', { divition_id: DIVISION_ARCOR }),
      wsGetAll('base/furniture')
    ]);
    if (resBureaus.success) setBureaus(resBureaus.data);
    if (resFurnitures.success) setFurnitures(resFurnitures.data);
  }

  useEffect(() => {
    if (control.open) loadCombos();
  }, [control.open]);

  //al abrir para otro registro se limpia lo que no viene del modelo
  useEffect(() => {
    setBPartnerSelect(undefined);
    setDataChanging({});
    setDataImport({});
  }, [control]);

  //la planilla trae una fila por control, con los códigos que ve el usuario
  useEffect(() => {
    if (dataImport?.success) {
      setItems(
        dataImport.data.map((f) => ({
          bureau_code: limpio(f['MESA']),
          CardCode: limpio(f['CLIENTE']),
          furniture_code: limpio(f['MUEBLE'])
        }))
      );
    } else if (dataImport?.success === false) {
      setItems([]);
    }
  }, [dataImport]);

  //recién cuando llegó el combo se puede preseleccionar, y comparando como texto
  useEffect(() => {
    if (furnitures.length > 0 && control?.base_furniture_id) {
      handleChange('base_furniture_id', String(control.base_furniture_id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [furnitures, control]);

  const etiquetaMueble = (f) => `${f.code ? f.code + ' - ' : ''}${f.description}`;

  const bureauSelect =
    bureaus.find((b) => String(b.id) === String(dataChanging.base_bureau_id)) || null;
  const furnitureSelect =
    furnitures.find((f) => String(f.id) === String(dataChanging.base_furniture_id)) || null;

  return (
    <>
      {openModalBPartner ? (
        <ModalFilterBPartner
          open={openModalBPartner}
          setOpen={setOpenModalBPartner}
          cardType="C"
          entity="base/customer-furniture/customers"
          filterProps={{ base_bureau_id: bureauSelect?.id }}
          setBPartnerSelect={setBPartnerSelect}
          extraFields={[{ Header: 'Dirección', accessor: 'Address2' }]}
        />
      ) : undefined}

      <Modal
        title="Control de mueble"
        model={control}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        entity={importado ? 'base/customer-furniture/multiple' : 'base/customer-furniture'}
        dataForce={
          importado
            ? { items }
            : esNuevo
            ? {
                base_business_partner_id: bPartnerSelect?.base_business_partner_id,
                base_address_id: bPartnerSelect?.base_address_id,
                base_furniture_id: furnitureSelect?.id
              }
            : { base_furniture_id: furnitureSelect?.id }
        }
      >
        {esNuevo ? (
          <span style={{ display: 'flex', alignItems: 'flex-end' }}>
            <Autocomplete
              options={bureaus}
              value={bureauSelect}
              getOptionLabel={(item) => (item.code ? `${item.code} - ${item.description}` : '')}
              getOptionSelected={(option, val) => String(option.id) === String(val.id)}
              renderInput={(params) => (
                <TextField {...params} label="Mesa" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {
                handleChange('base_bureau_id', item?.id);
                //al cambiar de mesa el cliente elegido deja de tener sentido
                setBPartnerSelect(undefined);
                setDataImport(null);
              }}
              disabled={importado}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <ImportExcel
              fileInputId="file-excel-control-muebles"
              setDataImport={setDataImport}
              btnColor="success"
              validDuplicate="MUEBLE"
              sortDuplicate="MUEBLE"
              downTemplate={{
                fileNameDown: 'Plantilla de control de muebles',
                fields: COLUMNAS_EXCEL
              }}
            />
          </span>
        ) : undefined}

        {importado ? (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile} — {items.length} fila(s)
          </p>
        ) : (
          <>
            {esNuevo ? (
              <TextField
                key={openModalBPartner + (bPartnerSelect?.CardName || '')}
                label="Cliente"
                type="text"
                margin="normal"
                fullWidth
                defaultValue={bPartnerSelect?.CardName || ''}
                helperText={bPartnerSelect?.Address2 || 'Elija la mesa y busque el cliente'}
                onFocus={(e) => {
                  e.preventDefault();
                  e.currentTarget.blur();
                }}
                required
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      style={{ cursor: bureauSelect ? 'pointer' : 'not-allowed', color: '#07c107' }}
                      onClick={() => bureauSelect && setOpenModalBPartner(true)}
                      position="start"
                    >
                      <Search />
                    </InputAdornment>
                  )
                }}
              />
            ) : (
              <TextField
                label="Cliente"
                margin="normal"
                fullWidth
                value={`${control?.customer?.CardCode || ''} - ${control?.customer?.CardName || ''}`}
                helperText={control?.address?.Address2 || ''}
                InputProps={{ readOnly: true }}
              />
            )}

            <Autocomplete
              options={furnitures}
              value={furnitureSelect}
              getOptionLabel={(item) => (item.description ? etiquetaMueble(item) : '')}
              getOptionSelected={(option, val) => String(option.id) === String(val.id)}
              renderInput={(params) => (
                <TextField {...params} label="Mueble" margin="normal" fullWidth required />
              )}
              onChange={(e, item) => handleChange('base_furniture_id', item?.id)}
            />

            {/* La baja no se hace acá: va por el botón del listado, que ademas
                libera el mueble. */}
          </>
        )}
      </Modal>
    </>
  );
});
